<template>
  <MultiAxesChart
    :gridLineColor="chart.gridLineColor"
    :thousandsSep="chart.thousandsSep"
    :decimalPoint="chart.decimalPoint"
    :height="chart.height"
    :xAxis="chart.xAxis"
    :yAxis="chart.yAxis"
    :series="chart.series"
    :legend="chart.legend"
    :crosshair="chart.crosshair"
    :tooltip="chart.tooltip"
    :plotOptions="chart.plotOptions"
    :customStyles="chart.customStyles"
  />
</template>

<script>
import { MultiAxesChart } from 'vuejs-highcharts'
import { convertToCurrencyBRL, formatNumber } from 'utils/functions'
import moment from 'moment'

export default {
  name: 'Chart',
  props: {
    data: {
      type: Object
    }
  },
  components: {
    MultiAxesChart
  },
  computed: {
    currentLocale () {
      if (!this.$i18n) return
      return this.$i18n.locale.split('_').join('-')
    }
  },
  data () {
    return {
      chart: {}
    }
  },
  methods: {
    setBorderRadius (arr) {
      return arr.length <= 15 ? 5 : 2
    },

    renderHTMLDate (dateArray, complementArray) {
      return dateArray.concat(complementArray).map((item, index) => {
        if (item) {
          const date = moment(item).format('DD/MM')
          const dayNumber = dateArray.length > 1 ? new Date(item + 'T00:00:00').getDay() : 1
          return `<span class="day day-${dayNumber} index-${index}" data-value="${item}">${date}</span>`
        }

        return ''
      })
    },

    renderTooltipHTML (context) {
      const { points = [] } = context || {}
      const doc = new DOMParser().parseFromString(context.x, 'text/xml')
      const value = doc.querySelector('span').getAttribute('data-value')
      const day = moment(value).format('dddd')
      const date = moment(value).format('DD/MM/YYYY')
      const renderHTML = (item) => {
        const color = item.color
        const name = item.series.name
        const val = name !== 'Corridas' ? convertToCurrencyBRL(item.y) : formatNumber(item.y)
        return `<span style="color: ${color}; font-size: 10px;">● </span><span style="font-size: 10px; color: #fff;">${name}: </span><span style="font-size: 10px; color: #fff; line-height: 20;">${val}</span><br>`
      }

      return `
        <div>
          <span>
            <span style="font-size: 10px; color: #fff; display: block;">${day}</span><br>
            <span style="font-size: 10px; font-weight: bold; color: #fff;">${date}</span><br>
          </span><br>
          ${points.map(item => renderHTML(item)).join('')}
        </div>
      `
    },

    renderChart () {
      const dateArray = [...this.data.date]
      const diff = 15 - dateArray.length
      const complementArray = Array.from({ length: diff }, (_, idx) => '')
      const categories = this.renderHTMLDate(dateArray, complementArray)
      const vm = this

      this.chart = {
        backgroundColor: '#fff',
        gridLineColor: '#ccd6eb',
        thousandsSep: '.',
        decimalPoint: ',',
        height: 294,
        crosshair: true,
        xAxis: [
          {
            categories,
            crosshair: true,
            labels: {
              autoRotation: 0,
              overflow: 'allow'
            }
          }
        ],
        yAxis: [
          {
            title: { text: '' },
            opposite: false
          },
          {
            title: { text: '' },
            opposite: false
          },
          {
            title: { text: '' },
            opposite: true
          }
        ],
        series: [
          {
            name: 'Corridas',
            type: 'column',
            color: '#00aeff',
            yAxis: 1,
            data: [...this.data.amount].concat(complementArray)
          },
          {
            name: 'Valor',
            type: 'column',
            color: '#2fcc70',
            data: [...this.data.totalFare].concat(complementArray)
          },
          {
            name: 'Ticket médio',
            type: 'line',
            color: '#ffb400',
            yAxis: 2,
            data: [...this.data.averageFare].concat(complementArray),
            marker: {
              lineWidth: 1,
              lineColor: '#ffb400',
              fillColor: 'white'
            }
          }
        ],
        legend: {
          align: 'right',
          verticalAlign: 'top',
          itemMarginBottom: 10
        },
        customStyles: {
          color: '#666',
          fontFamily: 'Montserrat'
        },
        plotOptions: {
          column: {
            borderRadius: this.setBorderRadius(dateArray)
          }
        },
        tooltip: {
          backgroundColor: 'rgba(0,0,0,.7)',
          borderColor: 'none',
          borderRadius: 10,
          shadow: false,
          formatter () {
            return vm.renderTooltipHTML(this)
          }
        }
      }
    }
  },
  created () {
    moment.locale(this.currentLocale)
    this.renderChart()
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
  max-width: 800px;

  .vuejs-highcharts {
    background-color: #fff;
    /* padding: 20px; */
  }
}

.select__container {
  margin-bottom: 20px;
}

.select__container:before,
.select__container:after {
  clear: both;
  content: '';
  display: block;
  width: 100%;
}

.select {
  border: none;
  float: right;
  padding: 8px;
}
</style>

<style lang="scss">
.highcharts-axis-labels.highcharts-xaxis-labels .day {
  opacity: 0;
  visibility: hidden;
  position: relative;
  z-index: 1;
}

.highcharts-axis-labels.highcharts-xaxis-labels .day.day-1,
.highcharts-axis-labels.highcharts-xaxis-labels .day.index-0:not(.day-0) {
  opacity: 1;
  visibility: visible;
}
</style>
